import React, { Component } from "react";
import { withCookies } from "react-cookie";
import Loader from "dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent";
import { ToastContainer } from "react-toastify";

import Validator from "./../../../Components/FormComponent/Validator";

import HSGHeader from "../../HSGHeaderContainer";
import HSGFooter from "../../HSGFooterContainer";
import HSGNavigation from "../../HSGNavigationContainer";

import Profile from "./Components/Profile"

import HSGModalComponent from "../../HSGModalComponent/HSGModalComponent";
import DialogForgotPassword from "../../DialogForgotPasswordContainer";
import InvitationRequest from "../../InvitationRequestContainer"; 

import "./App.css";
import "../../../Themes/Generic.css";
import "../../../Themes/HSGStyles.css";

const STRING_MODAL_FORGOT_PASSWORD_HEAD = "Would you like to reset your password?";
const STRING_MODAL_FORGOT_PASSWORD_CONTENT = (username) =>
    `Your username is ${username}. And can be used next time you log in. `;
const ERROR_PASSWORD_DO_NOT_MATCH = "Password do not match";

const STRING_BTN_SKIP = "Skip";
const STRING_BTN_SUBMIT = "Submit";

const MAP_SCREENS = {
    RECOVER: 0,
    OPTION: 1,
    OTP: 2,
    MAGIC_LINK: 3,
    RESET_PASSWORD: 4,
}

class App extends Component {
    constructor(props) {
        super(props);

        this.state = {
            childListFetched: false,
            dimensions: {},

            showModalInvitationRequest: false, 
            invitationLinkSuccessUpdated: false,
            showSetPasswordModal: false
        };
    }

    getCurrentDimensions() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }

    updateCurrentDimensions() {
        this.setState({ dimensions: this.getCurrentDimensions() });
    }

    componentDidMount() {
        this.updateCurrentDimensions();
        window.addEventListener("resize", this.updateCurrentDimensions());
        document.addEventListener('contextmenu', event => event.preventDefault());


        // if (this.props.isMagicLinkUsed && this.props.isMagicLinkSuccess && !this.props.magicLinkMeta.hideForgotPassword) {
        //     this.setState({ showSetPasswordModal: true });
        // }

        if (this.props.setPassword) {
            this.setState({ showSetPasswordModal: true });
        }

        if (this.props.allowInvitationLinkUpdate && this.props.invitationLinkUpdate && this.props.invitationLinkUpdate.length) {
            this.props.invitationRequestSuccess(this.props.invitationLinkUpdate)
        }

        if (!this.props.isGuestLogin) {
            this.props.getUser()
            this.props.s3Access()
        } 
    }

    componentWillReceiveProps(newProps) {
        if (newProps.user.userId && !newProps.isGuestLogin && !this.state.childListFetched) {
            this.setState({ childListFetched: true });
            this.props.fetchChildList(newProps.user.userId, newProps.currentChildId);
        }

        if (newProps.user.userId !== this.props.user.userId && !newProps.isGuestLogin) {
            this.setState({ childListFetched: true });
            this.props.fetchChildList(newProps.user.userId, newProps.currentChildId);
        }

        if (newProps.showInvitationLinkModal !== this.props.showInvitationLinkModal) {
            this.setState({ showModalInvitationRequest: newProps.showInvitationLinkModal, showModalInvalidInvitationRequest: !newProps.isInvitationLinkSuccess });
        }

        if (newProps.user !== this.props.user && newProps.user.userId && !newProps.isGuestLogin && newProps.user.userId === this.props.user.userId) {
            // this.setState({ childListFetched: true });
            this.props.fetchChildList(newProps.user.userId, newProps.childList[newProps.childCurrent] ? newProps.childList[newProps.childCurrent].userId : null);
        }

        // if (newProps.allowInvitationLinkUpdate && newProps.allowInvitationLinkUpdate !== this.props.allowInvitationLinkUpdate && newProps.invitationLink) {
        //     // this.props.invitationRequestSuccess(newProps.invitationLink)
        //     window.location.reload(false)
        // }
    }

    setPasswordModal = () => (
        <DialogForgotPassword
            show={this.state.showSetPasswordModal || false}
            onClose={() => this.setState({showSetPasswordModal: false})}
            onHide={() => {}}
            hideClose={true}
            type={MAP_SCREENS.RESET_PASSWORD}
        />
    );

    invitationLinkModal = () => (
        <InvitationRequest
            show={this.state.showModalInvitationRequest}
            isInvalidRequest={this.state.showModalInvalidInvitationRequest}
            onClose={() => this.setState({showModalInvitationRequest: false})}
        />
    )

    render() {
        const dimensions = this.state.dimensions;
        return (
            <div>
               {this.props.sidebar && (
                <div className="sideDrawer">
                    <HSGNavigation />
                </div>
                )}
                {
                    <div style={{ minHeight: dimensions.height }}>
                        <HSGHeader showModalUserProfile={()=>this.props.toggleUserProfileModal(true, 'update profile')}/>
                        <Loader blockUI={true} isLoading={!!(this.props.isLoading || this.props.isComponentLoading)} />
                        <div className="container-fluid hsg-app-main-background hsg-app-main-font">
                            <div className="col-md-3 col-lg-2 padding-0 hidden-xs hidden-sm">
                                <HSGNavigation />
                            </div>
                            <div className="col-md-9 col-lg-10 padding-right-0 hsg-no-mobile-padding">
                                {this.props.children}
                            </div>
                        </div>
                        <ToastContainer />

                        {
                            this.props.showModalUserProfile && 
                            <Profile
                                show={this.props.showModalUserProfile}
                                user={this.props.user}
                                
                                onClose={()=>this.props.toggleUserProfileModal(false)}
                                changePassword={(password)=>this.props.changePassword(password)}
                                
                                updateUser={this.props.updateUser}

                                signUpFormErrorEmailAddress={this.state.signUpFormErrorEmailAddress}
                                getCovidStats = {(state,city) => this.props.getCovidGlobalDashboard(state,city)}
                                emailVerified={this.props.emailVerified}
                                emailAvailable={this.props.emailAvailable}
                                totalCovidData = {this.props.totalCovidData}
                                checkValidationResponseType={this.props.checkValidationResponseType}
                                modalTypeHandler = {this.props.modalTypeHandler}
                                checkEmailAvailability={this.props.checkEmailAvailability}
                                changeValidationResponseType={this.props.changeValidationResponseType}
                                updateUserProfile={this.props.updateUserProfile}
                                fetchChildList={this.props.fetchChildList}
                                postUserLocation = {(location) => this.props.postUserLocation(location)}
                                s3Access={this.props.s3AccessResponse}
                                getUser = {this.props.getUser}
                            />
                        }

                        {this.setPasswordModal()}
                        {this.invitationLinkModal()}
                        {/* <HSGFooter /> */}
                    </div>
                }
            </div>
        );
    }
}

export default withCookies(App);
